import React from 'react'
import { Input } from '../../components/components'
import axios from 'axios'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

const inputAttribute = [
  {
    type: 'text',
    name: '_id',
    placeholder: 'Username',
  },
  {
    type: 'text',
    name: 'fname',
    placeholder: 'First Name',
  },
  {
    type: 'text',
    name: 'lname',
    placeholder: 'Last Name',
  },
  {
    type: 'select',
    name: 'gender',
    placeholder: 'Gender',
  },
  {
    type: 'email',
    name: 'email',
    placeholder: 'Email',
  },
  {
    type: 'date',
    name: 'dob',
    placeholder: 'Date Of Birth',
  },
  {
    type: 'password',
    name: 'password',
    placeholder: 'Password',
  },
  {
    type: 'password',
    name: 'rePassword',
    placeholder: 'Re-enter Password',
  },
]

function Signup() {
  const [userData, setUserData] = useState({
    _id: '',
    fname: '',
    lname: '',
    gender: '',
    email: '',
    dob: '',
    password: '',
    rePassword: '',
  })
  const navigate = useNavigate()

  function handleInput(e) {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }
  function signup() {
    axios
      .post(`${process.env.REACT_APP_API_URL}/search_user`, {
        uid: userData._id,
      })
      .then((res) => {
        if (res.data === '') {
          axios
            .post(`${process.env.REACT_APP_API_URL}/signup`, { userData })
            .then(() => {
              navigate('/login')
            })
        } else {
          alert(userData._id + ' already used, try another username')
        }
      })
  }
  return (
    <div>
      <h3 className="col-12 mt-3">Sign Up</h3>
      {inputAttribute.map((val, index) => {
        return (
          <div className="col-md-4 col-10 mt-3" key={index}>
            <Input
              type={val.type}
              className="form-control w-75 p-2"
              name={val.name}
              placeholder={val.placeholder}
              onChange={(e) => handleInput(e)}
              style={{ width: '32vh' }}
            />
          </div>
        )
      })}
      <div className="col-12 text-muted mt-3">
        Already have an account?{' '}
        <Link to={'/login'} className="text-muted">
          Login
        </Link>
      </div>
      <div className="mt-2">
        <button
          type="button"
          onClick={signup}
          className="btn btn-sm p-2 fs-6 w-25"
          style={{ backgroundColor: '#0696ff', color: '#ffffff' }}
        >
          Submit
        </button>
      </div>
    </div>
  )
}

export default Signup
